import React from "react"
import { useI18next, useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const capsulePlans = ["starter", "growth", "advanced", "ultimate"]

const isPaidPlan = plan => {
  return capsulePlans.includes(plan)
}

const SupportArticlePlans = ({ plans }) => {
  const { language } = useI18next()
  const { t } = useTranslation()

  if (plans.includes("free")) {
    return t("plans.all-plans")
  }

  if (
    plans.every(plan => isPaidPlan(plan)) &&
    plans.length === capsulePlans.length
  ) {
    return t("plans.all-paid-plans")
  }

  const formatter = new Intl.ListFormat(language, {
    style: "long",
    type: "conjunction",
  })

  return formatter.format(plans.map(plan => t(`plans.name.${plan}`)))
}

export default SupportArticlePlans
